import React from 'react';
import { Card } from './components/Card';
import { Box, Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { RoundedNumber } from './components/RoundedNumber';

export const MeusPedidos = ({ codCustomerSelected, infoCustomer, isLoading }) => {
  return (
    <Card py={'20px'} px={'20px'} isLoading={isLoading}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flexDir="column">
          <Text
            fontSize="18px"
            color="#2d2d2d"
            fontWeight="semibold"
            as={Link}
            to={`/pedidos-vendedor/${codCustomerSelected}?pedidos=true`}>
            Meus Pedidos
          </Text>
          <Flex gap={4} alignItems="center">
            <Box
              fontSize="14px"
              as={Link}
              to={`/resumo-producao?codVend=${infoCustomer?.codigo_vendedor}`}>
              <Flex alignItems="center" gap={2}>
                <Box w="3px" h="10px" bgColor="#FFA200" />
                em Produção: <strong>{infoCustomer?.pedidos_producao}</strong>
              </Flex>
            </Box>

            <Box
              fontSize="14px"
              as={Link}
              to={`/pedidos-aprovacao-vendedor/${codCustomerSelected}?pedidos_aprovacao=true`}>
              <Flex alignItems="center" gap={2}>
                <Box w="3px" h="10px" bgColor="#FFA200" />
                em Aprovação: <strong>{infoCustomer?.aprovacoes}</strong>
              </Flex>
            </Box>

            <Box
              fontSize="14px"
              as={Link}
              to={`/expedicao?codVend=${infoCustomer?.codigo_vendedor}`}>
              <Flex alignItems="center" gap={2}>
                <Box w="3px" h="10px" bgColor="#FFA200" />
                em Expedição: <strong>{infoCustomer?.pedidos_expedicao}</strong>
              </Flex>
            </Box>
          </Flex>
        </Flex>

        <RoundedNumber
          number={infoCustomer?.total_pedidos_vendedor}
          bgColor="#FFA200"
          w="45px"
          h="45px"
          fontSize="23px"
          to={`/pedidos-vendedor/${codCustomerSelected}?pedidos=true`}
        />
      </Flex>
    </Card>
  );
};
